import { j as u } from "./jsx-runtime-3tyXYecC.mjs";
import { useState as M, useRef as w, useEffect as U } from "react";
import { l as y } from "./lodash-5ofSKtz3.mjs";
import { m as W } from "./tss-DN0acMKN.mjs";
import { M as Z, d as J } from "./constants-CnFYFetN.mjs";
import { I as K } from "./icon-v2-DGtVEk7e.mjs";
import { f as b } from "./index-LyFokDcn.mjs";
import { S as I } from "./styled-box-DJEn6F3U.mjs";
import { L as F } from "./layout-box-DFBM-kSI.mjs";
import { F as tt } from "./flex-Cc3osQLf.mjs";
import { D as et } from "./divider-Dq5lrAFK.mjs";
import { T as z } from "./index-BlBizyO0.mjs";
import { c as it, g as nt } from "./_commonjsHelpers-BkfeUUK-.mjs";
import { T as S } from "./text-button-yPCa43NP.mjs";
import { I as ot } from "./X14x14-Dq3_cvuT.mjs";
const st = W()(({ mode: d, palette: t, spacing: i }) => ({
  container: {
    height: "100%",
    position: "absolute",
    width: "100%"
  },
  endorse: {
    position: "absolute",
    width: "calc(100% - 54px)",
    bottom: "32px",
    left: "27px",
    borderBottom: `2px solid ${t.gray[500]}`
  },
  icon: {
    fill: t.gray[600],
    paddingBottom: "10px"
  },
  initials: {
    width: "288px"
  },
  root: {
    position: "relative",
    backgroundColor: t.gray[100],
    borderRadius: i(1),
    height: "188px",
    maxWidth: "100%",
    outline: d === Z.Dye ? `1px solid ${J.main}` : void 0,
    width: "600px"
  },
  toggle: {
    display: "flex",
    justifyContent: "center",
    position: "absolute",
    top: "-12px",
    width: "100%"
  }
}));
/*!
 * Signature Pad v4.1.5 | https://github.com/szimek/signature_pad
 * (c) 2023 Szymon Nowak | Released under the MIT license
 */
class C {
  constructor(t, i, e, s) {
    if (isNaN(t) || isNaN(i))
      throw new Error(`Point is invalid: (${t}, ${i})`);
    this.x = +t, this.y = +i, this.pressure = e || 0, this.time = s || Date.now();
  }
  distanceTo(t) {
    return Math.sqrt(Math.pow(this.x - t.x, 2) + Math.pow(this.y - t.y, 2));
  }
  equals(t) {
    return this.x === t.x && this.y === t.y && this.pressure === t.pressure && this.time === t.time;
  }
  velocityFrom(t) {
    return this.time !== t.time ? this.distanceTo(t) / (this.time - t.time) : 0;
  }
}
class L {
  constructor(t, i, e, s, o, c) {
    this.startPoint = t, this.control2 = i, this.control1 = e, this.endPoint = s, this.startWidth = o, this.endWidth = c;
  }
  static fromPoints(t, i) {
    const e = this.calculateControlPoints(t[0], t[1], t[2]).c2, s = this.calculateControlPoints(t[1], t[2], t[3]).c1;
    return new L(t[1], e, s, t[2], i.start, i.end);
  }
  static calculateControlPoints(t, i, e) {
    const s = t.x - i.x, o = t.y - i.y, c = i.x - e.x, l = i.y - e.y, h = { x: (t.x + i.x) / 2, y: (t.y + i.y) / 2 }, n = { x: (i.x + e.x) / 2, y: (i.y + e.y) / 2 }, a = Math.sqrt(s * s + o * o), r = Math.sqrt(c * c + l * l), m = h.x - n.x, p = h.y - n.y, x = r / (a + r), f = { x: n.x + m * x, y: n.y + p * x }, g = i.x - f.x, _ = i.y - f.y;
    return {
      c1: new C(h.x + g, h.y + _),
      c2: new C(n.x + g, n.y + _)
    };
  }
  length() {
    let i = 0, e, s;
    for (let o = 0; o <= 10; o += 1) {
      const c = o / 10, l = this.point(c, this.startPoint.x, this.control1.x, this.control2.x, this.endPoint.x), h = this.point(c, this.startPoint.y, this.control1.y, this.control2.y, this.endPoint.y);
      if (o > 0) {
        const n = l - e, a = h - s;
        i += Math.sqrt(n * n + a * a);
      }
      e = l, s = h;
    }
    return i;
  }
  point(t, i, e, s, o) {
    return i * (1 - t) * (1 - t) * (1 - t) + 3 * e * (1 - t) * (1 - t) * t + 3 * s * (1 - t) * t * t + o * t * t * t;
  }
}
class rt {
  constructor() {
    try {
      this._et = new EventTarget();
    } catch {
      this._et = document;
    }
  }
  addEventListener(t, i, e) {
    this._et.addEventListener(t, i, e);
  }
  dispatchEvent(t) {
    return this._et.dispatchEvent(t);
  }
  removeEventListener(t, i, e) {
    this._et.removeEventListener(t, i, e);
  }
}
function at(d, t = 250) {
  let i = 0, e = null, s, o, c;
  const l = () => {
    i = Date.now(), e = null, s = d.apply(o, c), e || (o = null, c = []);
  };
  return function(...n) {
    const a = Date.now(), r = t - (a - i);
    return o = this, c = n, r <= 0 || r > t ? (e && (clearTimeout(e), e = null), i = a, s = d.apply(o, c), e || (o = null, c = [])) : e || (e = window.setTimeout(l, r)), s;
  };
}
class E extends rt {
  constructor(t, i = {}) {
    super(), this.canvas = t, this._drawningStroke = !1, this._isEmpty = !0, this._lastPoints = [], this._data = [], this._lastVelocity = 0, this._lastWidth = 0, this._handleMouseDown = (e) => {
      e.buttons === 1 && (this._drawningStroke = !0, this._strokeBegin(e));
    }, this._handleMouseMove = (e) => {
      this._drawningStroke && this._strokeMoveUpdate(e);
    }, this._handleMouseUp = (e) => {
      e.buttons === 1 && this._drawningStroke && (this._drawningStroke = !1, this._strokeEnd(e));
    }, this._handleTouchStart = (e) => {
      if (e.cancelable && e.preventDefault(), e.targetTouches.length === 1) {
        const s = e.changedTouches[0];
        this._strokeBegin(s);
      }
    }, this._handleTouchMove = (e) => {
      e.cancelable && e.preventDefault();
      const s = e.targetTouches[0];
      this._strokeMoveUpdate(s);
    }, this._handleTouchEnd = (e) => {
      if (e.target === this.canvas) {
        e.cancelable && e.preventDefault();
        const o = e.changedTouches[0];
        this._strokeEnd(o);
      }
    }, this._handlePointerStart = (e) => {
      this._drawningStroke = !0, e.preventDefault(), this._strokeBegin(e);
    }, this._handlePointerMove = (e) => {
      this._drawningStroke && (e.preventDefault(), this._strokeMoveUpdate(e));
    }, this._handlePointerEnd = (e) => {
      this._drawningStroke && (e.preventDefault(), this._drawningStroke = !1, this._strokeEnd(e));
    }, this.velocityFilterWeight = i.velocityFilterWeight || 0.7, this.minWidth = i.minWidth || 0.5, this.maxWidth = i.maxWidth || 2.5, this.throttle = "throttle" in i ? i.throttle : 16, this.minDistance = "minDistance" in i ? i.minDistance : 5, this.dotSize = i.dotSize || 0, this.penColor = i.penColor || "black", this.backgroundColor = i.backgroundColor || "rgba(0,0,0,0)", this._strokeMoveUpdate = this.throttle ? at(E.prototype._strokeUpdate, this.throttle) : E.prototype._strokeUpdate, this._ctx = t.getContext("2d"), this.clear(), this.on();
  }
  clear() {
    const { _ctx: t, canvas: i } = this;
    t.fillStyle = this.backgroundColor, t.clearRect(0, 0, i.width, i.height), t.fillRect(0, 0, i.width, i.height), this._data = [], this._reset(this._getPointGroupOptions()), this._isEmpty = !0;
  }
  fromDataURL(t, i = {}) {
    return new Promise((e, s) => {
      const o = new Image(), c = i.ratio || window.devicePixelRatio || 1, l = i.width || this.canvas.width / c, h = i.height || this.canvas.height / c, n = i.xOffset || 0, a = i.yOffset || 0;
      this._reset(this._getPointGroupOptions()), o.onload = () => {
        this._ctx.drawImage(o, n, a, l, h), e();
      }, o.onerror = (r) => {
        s(r);
      }, o.crossOrigin = "anonymous", o.src = t, this._isEmpty = !1;
    });
  }
  toDataURL(t = "image/png", i) {
    switch (t) {
      case "image/svg+xml":
        return typeof i != "object" && (i = void 0), `data:image/svg+xml;base64,${btoa(this.toSVG(i))}`;
      default:
        return typeof i != "number" && (i = void 0), this.canvas.toDataURL(t, i);
    }
  }
  on() {
    this.canvas.style.touchAction = "none", this.canvas.style.msTouchAction = "none", this.canvas.style.userSelect = "none";
    const t = /Macintosh/.test(navigator.userAgent) && "ontouchstart" in document;
    window.PointerEvent && !t ? this._handlePointerEvents() : (this._handleMouseEvents(), "ontouchstart" in window && this._handleTouchEvents());
  }
  off() {
    this.canvas.style.touchAction = "auto", this.canvas.style.msTouchAction = "auto", this.canvas.style.userSelect = "auto", this.canvas.removeEventListener("pointerdown", this._handlePointerStart), this.canvas.removeEventListener("pointermove", this._handlePointerMove), this.canvas.ownerDocument.removeEventListener("pointerup", this._handlePointerEnd), this.canvas.removeEventListener("mousedown", this._handleMouseDown), this.canvas.removeEventListener("mousemove", this._handleMouseMove), this.canvas.ownerDocument.removeEventListener("mouseup", this._handleMouseUp), this.canvas.removeEventListener("touchstart", this._handleTouchStart), this.canvas.removeEventListener("touchmove", this._handleTouchMove), this.canvas.removeEventListener("touchend", this._handleTouchEnd);
  }
  isEmpty() {
    return this._isEmpty;
  }
  fromData(t, { clear: i = !0 } = {}) {
    i && this.clear(), this._fromData(t, this._drawCurve.bind(this), this._drawDot.bind(this)), this._data = this._data.concat(t);
  }
  toData() {
    return this._data;
  }
  _getPointGroupOptions(t) {
    return {
      penColor: t && "penColor" in t ? t.penColor : this.penColor,
      dotSize: t && "dotSize" in t ? t.dotSize : this.dotSize,
      minWidth: t && "minWidth" in t ? t.minWidth : this.minWidth,
      maxWidth: t && "maxWidth" in t ? t.maxWidth : this.maxWidth,
      velocityFilterWeight: t && "velocityFilterWeight" in t ? t.velocityFilterWeight : this.velocityFilterWeight
    };
  }
  _strokeBegin(t) {
    this.dispatchEvent(new CustomEvent("beginStroke", { detail: t }));
    const i = this._getPointGroupOptions(), e = Object.assign(Object.assign({}, i), { points: [] });
    this._data.push(e), this._reset(i), this._strokeUpdate(t);
  }
  _strokeUpdate(t) {
    if (this._data.length === 0) {
      this._strokeBegin(t);
      return;
    }
    this.dispatchEvent(new CustomEvent("beforeUpdateStroke", { detail: t }));
    const i = t.clientX, e = t.clientY, s = t.pressure !== void 0 ? t.pressure : t.force !== void 0 ? t.force : 0, o = this._createPoint(i, e, s), c = this._data[this._data.length - 1], l = c.points, h = l.length > 0 && l[l.length - 1], n = h ? o.distanceTo(h) <= this.minDistance : !1, a = this._getPointGroupOptions(c);
    if (!h || !(h && n)) {
      const r = this._addPoint(o, a);
      h ? r && this._drawCurve(r, a) : this._drawDot(o, a), l.push({
        time: o.time,
        x: o.x,
        y: o.y,
        pressure: o.pressure
      });
    }
    this.dispatchEvent(new CustomEvent("afterUpdateStroke", { detail: t }));
  }
  _strokeEnd(t) {
    this._strokeUpdate(t), this.dispatchEvent(new CustomEvent("endStroke", { detail: t }));
  }
  _handlePointerEvents() {
    this._drawningStroke = !1, this.canvas.addEventListener("pointerdown", this._handlePointerStart), this.canvas.addEventListener("pointermove", this._handlePointerMove), this.canvas.ownerDocument.addEventListener("pointerup", this._handlePointerEnd);
  }
  _handleMouseEvents() {
    this._drawningStroke = !1, this.canvas.addEventListener("mousedown", this._handleMouseDown), this.canvas.addEventListener("mousemove", this._handleMouseMove), this.canvas.ownerDocument.addEventListener("mouseup", this._handleMouseUp);
  }
  _handleTouchEvents() {
    this.canvas.addEventListener("touchstart", this._handleTouchStart), this.canvas.addEventListener("touchmove", this._handleTouchMove), this.canvas.addEventListener("touchend", this._handleTouchEnd);
  }
  _reset(t) {
    this._lastPoints = [], this._lastVelocity = 0, this._lastWidth = (t.minWidth + t.maxWidth) / 2, this._ctx.fillStyle = t.penColor;
  }
  _createPoint(t, i, e) {
    const s = this.canvas.getBoundingClientRect();
    return new C(t - s.left, i - s.top, e, (/* @__PURE__ */ new Date()).getTime());
  }
  _addPoint(t, i) {
    const { _lastPoints: e } = this;
    if (e.push(t), e.length > 2) {
      e.length === 3 && e.unshift(e[0]);
      const s = this._calculateCurveWidths(e[1], e[2], i), o = L.fromPoints(e, s);
      return e.shift(), o;
    }
    return null;
  }
  _calculateCurveWidths(t, i, e) {
    const s = e.velocityFilterWeight * i.velocityFrom(t) + (1 - e.velocityFilterWeight) * this._lastVelocity, o = this._strokeWidth(s, e), c = {
      end: o,
      start: this._lastWidth
    };
    return this._lastVelocity = s, this._lastWidth = o, c;
  }
  _strokeWidth(t, i) {
    return Math.max(i.maxWidth / (t + 1), i.minWidth);
  }
  _drawCurveSegment(t, i, e) {
    const s = this._ctx;
    s.moveTo(t, i), s.arc(t, i, e, 0, 2 * Math.PI, !1), this._isEmpty = !1;
  }
  _drawCurve(t, i) {
    const e = this._ctx, s = t.endWidth - t.startWidth, o = Math.ceil(t.length()) * 2;
    e.beginPath(), e.fillStyle = i.penColor;
    for (let c = 0; c < o; c += 1) {
      const l = c / o, h = l * l, n = h * l, a = 1 - l, r = a * a, m = r * a;
      let p = m * t.startPoint.x;
      p += 3 * r * l * t.control1.x, p += 3 * a * h * t.control2.x, p += n * t.endPoint.x;
      let x = m * t.startPoint.y;
      x += 3 * r * l * t.control1.y, x += 3 * a * h * t.control2.y, x += n * t.endPoint.y;
      const f = Math.min(t.startWidth + n * s, i.maxWidth);
      this._drawCurveSegment(p, x, f);
    }
    e.closePath(), e.fill();
  }
  _drawDot(t, i) {
    const e = this._ctx, s = i.dotSize > 0 ? i.dotSize : (i.minWidth + i.maxWidth) / 2;
    e.beginPath(), this._drawCurveSegment(t.x, t.y, s), e.closePath(), e.fillStyle = i.penColor, e.fill();
  }
  _fromData(t, i, e) {
    for (const s of t) {
      const { points: o } = s, c = this._getPointGroupOptions(s);
      if (o.length > 1)
        for (let l = 0; l < o.length; l += 1) {
          const h = o[l], n = new C(h.x, h.y, h.pressure, h.time);
          l === 0 && this._reset(c);
          const a = this._addPoint(n, c);
          a && i(a, c);
        }
      else
        this._reset(c), e(o[0], c);
    }
  }
  toSVG({ includeBackgroundColor: t = !1 } = {}) {
    const i = this._data, e = Math.max(window.devicePixelRatio || 1, 1), s = 0, o = 0, c = this.canvas.width / e, l = this.canvas.height / e, h = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    if (h.setAttribute("xmlns", "http://www.w3.org/2000/svg"), h.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink"), h.setAttribute("viewBox", `${s} ${o} ${c} ${l}`), h.setAttribute("width", c.toString()), h.setAttribute("height", l.toString()), t && this.backgroundColor) {
      const n = document.createElement("rect");
      n.setAttribute("width", "100%"), n.setAttribute("height", "100%"), n.setAttribute("fill", this.backgroundColor), h.appendChild(n);
    }
    return this._fromData(i, (n, { penColor: a }) => {
      const r = document.createElement("path");
      if (!isNaN(n.control1.x) && !isNaN(n.control1.y) && !isNaN(n.control2.x) && !isNaN(n.control2.y)) {
        const m = `M ${n.startPoint.x.toFixed(3)},${n.startPoint.y.toFixed(3)} C ${n.control1.x.toFixed(3)},${n.control1.y.toFixed(3)} ${n.control2.x.toFixed(3)},${n.control2.y.toFixed(3)} ${n.endPoint.x.toFixed(3)},${n.endPoint.y.toFixed(3)}`;
        r.setAttribute("d", m), r.setAttribute("stroke-width", (n.endWidth * 2.25).toFixed(3)), r.setAttribute("stroke", a), r.setAttribute("fill", "none"), r.setAttribute("stroke-linecap", "round"), h.appendChild(r);
      }
    }, (n, { penColor: a, dotSize: r, minWidth: m, maxWidth: p }) => {
      const x = document.createElement("circle"), f = r > 0 ? r : (m + p) / 2;
      x.setAttribute("r", f.toString()), x.setAttribute("cx", n.x.toString()), x.setAttribute("cy", n.y.toString()), x.setAttribute("fill", a), h.appendChild(x);
    }), h.outerHTML;
  }
}
const ct = W()(({ palette: d, spacing: t, constructs: i }) => ({
  clear: {
    position: "absolute",
    right: t(3),
    top: t(2)
  },
  container: {
    height: `calc(100% - ${t(5)})`,
    paddingTop: t(5)
  },
  placeholder: {
    bottom: 0,
    color: b.ifFeature("encore", i.text.neutral.xStrong, d.gray[700]),
    lineHeight: t(3),
    padding: `${t(5)} 55px`,
    pointerEvents: "none",
    // Prevent element from being interactive
    position: "absolute"
  },
  root: {
    height: "100%"
  }
}));
var B = { exports: {} };
(function(d, t) {
  (function(i, e) {
    d.exports = e();
  })(it, function() {
    return function(i) {
      function e(o) {
        if (s[o]) return s[o].exports;
        var c = s[o] = { exports: {}, id: o, loaded: !1 };
        return i[o].call(c.exports, c, c.exports, e), c.loaded = !0, c.exports;
      }
      var s = {};
      return e.m = i, e.c = s, e.p = "", e(0);
    }([function(i, e) {
      function s(n) {
        var a = n.getContext("2d"), r = n.width, m = n.height, p = a.getImageData(0, 0, r, m).data, x = l(!0, r, m, p), f = l(!1, r, m, p), g = h(!0, r, m, p), _ = h(!1, r, m, p), T = _ - g + 1, k = f - x + 1, Y = a.getImageData(g, x, T, k);
        return n.width = T, n.height = k, a.clearRect(0, 0, T, k), a.putImageData(Y, 0, 0), n;
      }
      function o(n, a, r, m) {
        return { red: m[4 * (r * a + n)], green: m[4 * (r * a + n) + 1], blue: m[4 * (r * a + n) + 2], alpha: m[4 * (r * a + n) + 3] };
      }
      function c(n, a, r, m) {
        return o(n, a, r, m).alpha;
      }
      function l(n, a, r, m) {
        for (var p = n ? 1 : -1, x = n ? 0 : r - 1, f = x; n ? f < r : f > -1; f += p) for (var g = 0; g < a; g++) if (c(g, f, a, m)) return f;
        return null;
      }
      function h(n, a, r, m) {
        for (var p = n ? 1 : -1, x = n ? 0 : a - 1, f = x; n ? f < a : f > -1; f += p) for (var g = 0; g < r; g++) if (c(f, g, a, m)) return f;
        return null;
      }
      Object.defineProperty(e, "__esModule", { value: !0 }), e.default = s;
    }]);
  });
})(B);
var ht = B.exports;
const lt = /* @__PURE__ */ nt(ht);
function q(d) {
  const t = document.createElement("canvas");
  t.height = d.height, t.width = d.width;
  const i = t.getContext("2d", { willReadFrequently: !0 });
  return i !== null && i.drawImage(d, 0, 0), lt(t), t.toDataURL();
}
const dt = (d, t) => {
  const { maxFontSize: i, minFontSize: e } = t;
  P(d) ? V(d, i) : H(d, e);
}, P = (d) => {
  const { clientHeight: t, clientWidth: i, scrollWidth: e, scrollHeight: s } = d;
  return y.inRange(i, e - 2, e + 2) && y.inRange(t, s - 2, s + 2);
}, V = (d, t = D) => {
  const i = parseInt(d.style.fontSize, 10) || v, e = Math.ceil((1 + Q) * i);
  t !== -1 && e > t || (d.style.fontSize = `${e}px`, P(d) ? V(d, t) : d.style.fontSize = `${i}px`);
}, H = (d, t = v) => {
  const i = parseInt(d.style.fontSize, 10) || v, e = Math.ceil((1 - Q) * i);
  d.style.fontSize = `${e}px`, !(e <= t) && P(d) === !1 && H(d, t);
}, Q = 0.1, v = 45, D = 90, N = window.jQuery ? $.__("Clear") : "Clear", ut = window.jQuery ? $.__("Draw your signature...") : "Draw your signature...", xt = window.jQuery ? $.__("Draw your initials...") : "Draw your initials...", A = (d) => {
  const { biId: t, onChange: i, placeholder: e, variant: s } = d, { classes: o } = ct(), [c, l] = M(!1), h = w(null), n = w(null), a = w(null), r = e || (s === "initials" ? xt : ut);
  function m() {
    n.current !== null && i(q(n.current));
  }
  function p() {
    var x;
    (x = a.current) == null || x.clear(), l(!1), i("");
  }
  return U(() => {
    var x, f;
    n.current !== null && (h.current !== null && (n.current.height = h.current.clientHeight, n.current.width = h.current.clientWidth), a.current = new E(n.current), (x = a.current) == null || x.addEventListener("beginStroke", () => {
      c || l(!0);
    }), (f = a.current) == null || f.addEventListener("endStroke", () => m()));
  }, []), /* @__PURE__ */ u.jsxs("div", { className: o.root, children: [
    /* @__PURE__ */ u.jsx("div", { className: o.container, ref: h, children: /* @__PURE__ */ u.jsx("canvas", { ref: n }) }),
    c ? /* @__PURE__ */ u.jsx(u.Fragment, { children: b.ifFeature(
      "encore",
      /* @__PURE__ */ u.jsx(F, { margin: "12px", position: "absolute", right: 0, top: 0, children: /* @__PURE__ */ u.jsx(
        S,
        {
          color: "inherit",
          "data-bi-id": t ? `${t}-type-clear-button` : void 0,
          onClick: p,
          size: "small",
          children: N
        }
      ) }),
      /* @__PURE__ */ u.jsx("div", { className: o.clear, children: /* @__PURE__ */ u.jsx(
        S,
        {
          color: "secondary",
          "data-bi-id": t ? `${t}-draw-clear-button` : void 0,
          onClick: p,
          size: "small",
          children: N
        }
      ) })
    ) }) : /* @__PURE__ */ u.jsx("span", { className: o.placeholder, children: r })
  ] });
}, X = '4rem "Ephesis"', mt = W()(({ palette: d, spacing: t, constructs: i }) => ({
  clear: {
    position: "absolute",
    right: t(3),
    top: t(2)
  },
  container: {
    alignItems: "flex-end",
    display: "flex",
    height: "100%",
    paddingTop: `${t(6)}`,
    boxSizing: "border-box"
  },
  input: {
    background: "none",
    border: "none",
    font: X,
    height: "100%",
    padding: `${t(4)} ${t(3)} 0px ${t(3)}`,
    textIndent: "29px",
    width: "100%"
  },
  placeholder: {
    bottom: 0,
    color: b.ifFeature("encore", i.text.neutral.xStrong, d.gray[700]),
    lineHeight: t(3),
    padding: `${t(5)} 55px`,
    pointerEvents: "none",
    // Prevent element from being interactive
    position: "absolute"
  },
  root: {
    height: "100%",
    borderRadius: t(1),
    "&:focus-within": {
      outline: `2px solid ${d.primary.lightest}`
    }
  }
})), R = window.jQuery ? $.__("Clear") : "Clear", pt = window.jQuery ? $.__("Type your name...") : "Type your name...", ft = window.jQuery ? $.__("Type your initials...") : "Type your initials...", O = (d) => {
  const { biId: t, onChange: i, placeholder: e, variant: s } = d, { classes: o } = mt(), [c, l] = M(""), h = w(null), n = w(document.createElement("canvas")), a = w(n.current.getContext("2d", { willReadFrequently: !0 })), r = w(null), m = e || (s === "initials" ? ft : pt), p = `signature-placeholder-${y.uniqueId()}`;
  function x(_) {
    !c && r.current && (r.current.style.fontSize = _.target.style.fontSize || `${D}px`), !(r.current && !P(r.current) && parseInt(r.current.style.fontSize, 10) <= v) && (l(_.target.value), r.current && _.target.style.fontSize && dt(r.current, {
      maxFontSize: D,
      minFontSize: v
    }), g(_.target.value));
  }
  function f() {
    var _;
    l(""), g(""), (_ = r.current) == null || _.focus();
  }
  function g(_) {
    a.current !== null && _ !== "" ? (a.current.clearRect(0, 0, n.current.width, n.current.height), a.current.fillText(_, 10, n.current.height / 2, n.current.width - 30), i(q(n.current), _)) : i("");
  }
  return U(() => {
    h.current !== null && (n.current.height = h.current.clientHeight, n.current.width = h.current.clientWidth), a.current !== null && (a.current.font = X);
  }, []), /* @__PURE__ */ u.jsxs("div", { className: o.root, children: [
    /* @__PURE__ */ u.jsx("div", { className: o.container, ref: h, children: /* @__PURE__ */ u.jsx(
      "input",
      {
        "aria-labelledby": p,
        className: o.input,
        onChange: x,
        ref: r,
        type: "text",
        value: c
      }
    ) }),
    c ? /* @__PURE__ */ u.jsx(u.Fragment, { children: b.ifFeature(
      "encore",
      /* @__PURE__ */ u.jsx(F, { margin: "12px", position: "absolute", right: 0, top: 0, children: /* @__PURE__ */ u.jsx(
        S,
        {
          color: "inherit",
          "data-bi-id": t ? `${t}-type-clear-button` : void 0,
          onClick: f,
          size: "small",
          children: R
        }
      ) }),
      /* @__PURE__ */ u.jsx("div", { className: o.clear, children: /* @__PURE__ */ u.jsx(
        S,
        {
          color: "secondary",
          "data-bi-id": t ? `${t}-type-clear-button` : void 0,
          onClick: f,
          size: "small",
          children: R
        }
      ) })
    ) }) : /* @__PURE__ */ u.jsx("span", { className: o.placeholder, id: p, children: m })
  ] });
}, j = window.jQuery ? $.__("Draw") : "Draw", G = window.jQuery ? $.__("Type") : "Type", Wt = (d) => {
  const { biId: t, initialInputMode: i = "draw", onChange: e, placeholderDrawMode: s, placeholderTypeMode: o, variant: c } = d, { classes: l, cx: h } = st(), [n, a] = M(i);
  function r(p, x) {
    e(p, n, x);
  }
  function m(p) {
    const x = p.value === j ? "draw" : "type";
    a(x), e("", x);
  }
  return /* @__PURE__ */ u.jsx(u.Fragment, { children: b.ifFeature(
    "encore",
    /* @__PURE__ */ u.jsxs(
      I,
      {
        borderColor: "neutral-weak",
        borderRadius: "medium",
        borderStyle: "solid",
        "data-bi-id": t,
        "data-fabric-component": "Signature",
        height: "188px",
        maxWidth: "100%",
        position: "relative",
        width: "600px",
        children: [
          /* @__PURE__ */ u.jsxs(I, { bottom: "32px", left: "27px", paddingBottom: "4px", position: "absolute", width: "calc(100% - 54px)", children: [
            /* @__PURE__ */ u.jsx(K, { color: "neutral-extra-strong", name: "xmark-regular", size: 20 }),
            /* @__PURE__ */ u.jsx(et, { color: "neutral-weak" })
          ] }),
          /* @__PURE__ */ u.jsxs(F, { height: "100%", position: "absolute", width: "100%", children: [
            /* @__PURE__ */ u.jsx(tt, { justifyContent: "center", position: "absolute", top: "-22px", width: "100%", children: /* @__PURE__ */ u.jsx(
              z,
              {
                isChecked: n === "draw",
                isView: !1,
                name: `fab-Signature-Toggle-${y.uniqueId()}`,
                onChange: (p, x) => m(x),
                size: "large",
                value: [j, G]
              }
            ) }),
            n === "draw" ? /* @__PURE__ */ u.jsx(A, { biId: t, onChange: r, placeholder: s, variant: c }) : /* @__PURE__ */ u.jsx(O, { biId: t, onChange: r, placeholder: o, variant: c })
          ] })
        ]
      }
    ),
    /* @__PURE__ */ u.jsxs("div", { className: h(l.root, { [l.initials]: c === "initials" }), "data-bi-id": t, children: [
      /* @__PURE__ */ u.jsx("div", { className: h(l.endorse, l.icon), children: /* @__PURE__ */ u.jsx(ot, {}) }),
      /* @__PURE__ */ u.jsxs("div", { className: l.container, children: [
        /* @__PURE__ */ u.jsx("div", { className: l.toggle, children: /* @__PURE__ */ u.jsx(
          z,
          {
            isChecked: n === "draw",
            isView: !1,
            name: `fab-Signature-Toggle-${y.uniqueId()}`,
            onChange: (p, x) => m(x),
            size: "regular",
            value: [j, G]
          }
        ) }),
        n === "draw" ? /* @__PURE__ */ u.jsx(A, { biId: t, onChange: r, placeholder: s, variant: c }) : /* @__PURE__ */ u.jsx(O, { biId: t, onChange: r, placeholder: o, variant: c })
      ] })
    ] })
  ) });
};
export {
  Wt as S
};
//# sourceMappingURL=signature-CGSsMRY7.mjs.map
